import React from "react";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Home from "./Home";
import NotFound from "./NotFound";
import ImageDetail from "./ImageDetail";
import TopicHub from "./TopicHub";
import InfoPage from "./InfoPage";
import Blog, { blogPosts } from "./Blog";
import infoPages from "./infoPages.json";
import { SUPPORTED_LOCALES } from "./i18n";

const localizedRoutes = SUPPORTED_LOCALES.flatMap((locale) => [
  ...blogPosts.map((post) => ({
    path: `/${locale}/${post.slug}`,
    element: <Blog forcedLocale={locale} postId={post.id} />,
  })),
  ...infoPages.map((page) => ({
    path: `/${locale}/${page.slug}`,
    element: <InfoPage forcedLocale={locale} pageId={page.id} />,
  })),
  {
    path: `/${locale}/ausmalbild/:seoSlug`,
    element: <ImageDetail forcedLocale={locale} />,
  },
  {
    path: `/${locale}/themen/:hubSlug`,
    element: <TopicHub forcedLocale={locale} />,
  },
  {
    path: `/${locale}/view/*`,
    element: <ImageDetail forcedLocale={locale} />,
  },
  {
    path: `/${locale}/:categoryTag?`,
    element: <Home forcedLocale={locale} />,
  },
  {
    path: `/${locale}/*`,
    element: <NotFound forcedLocale={locale} />,
  },
]);

function App() {
  const router = createBrowserRouter([
    ...localizedRoutes,
    {
      path: "/ausmalbild/:seoSlug",
      element: <ImageDetail />,
    },
    {
      path: "/themen/:hubSlug",
      element: <TopicHub />,
    },
    {
      path: "/view/*",
      element: <ImageDetail />,
    },
    ...blogPosts.map((post) => ({
      path: `/${post.slug}`,
      element: <Blog forcedLocale="de" postId={post.id} />,
    })),
    ...infoPages.map((page) => ({
      path: `/${page.slug}`,
      element: <InfoPage pageId={page.id} />,
    })),
    {
      path: "/:categoryTag?",
      element: <Home />,
    },
    {
      path: "*",
      element: <NotFound />,
    },
  ]);

  return (
    <RouterProvider
      future={{
        v7_startTransition: true,
      }}
      router={router}
    />
  );
}

export default App;
